// extracted by mini-css-extract-plugin
module.exports = {"add":"add__FRCAg","icon":"icon__3Wb6t"};